import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import AsyncSelect from 'react-select/async';
import {
    faCamera,
    faUpload,
    faCheckCircle,
    faTruck,
    faFileAlt,
    faRemove,
    faTrash,
} from "@fortawesome/free-solid-svg-icons";
import { Gatepass, GatepassAttachment, GatepassDocument, Session } from "service";
import ArthaGateway from "service/ArthaGateway";
import moment from "moment";
import { useSelector } from "react-redux";
import { RootState } from "store/store";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";

export const GatepassEntry = () => {
    const GATEPASSTYPE_VISITOR = 1;
    const GATEPASSTYPE_MATERIAL = 2;
    const gatepassTypes = [
        { value: GATEPASSTYPE_VISITOR, label: "Visitor" },
        { value: GATEPASSTYPE_MATERIAL, label: "Material" },
    ];

    const RECEIPT_MODE_MANUAL = "Manual";
    const RECEIPT_MODE_COURIER = "Courier";
    const RECEIPT_MODE_TRANSPORTER = "Transporter";
    const RECEIPT_MODE_OWNVEHICLE = "OwnVehicle";

    const receiptModes = [
        { value: RECEIPT_MODE_MANUAL, label: "Manual" },
        { value: RECEIPT_MODE_COURIER, label: "Courier" },
        { value: RECEIPT_MODE_TRANSPORTER, label: "Transporter" },
        { value: RECEIPT_MODE_OWNVEHICLE, label: "Own Vehicle" },
    ];

    const visitPurposes = [
        { value: "Meeting", label: "Meeting" },
        { value: "Delivery", label: "Delivery" },
        { value: "Pickup", label: "Pickup" },
        { value: "Maintenance", label: "Maintenance" },
        { value: "Installation", label: "Installation" },
        { value: "Audit", label: "Audit" },
        { value: "Inspection", label: "Inspection" },
        { value: "Training", label: "Training" },
        { value: "Interview", label: "Interview" },
        { value: "Personal", label: "Personal" },
        { value: "Official", label: "Official" },
        { value: "Other", label: "Other" }
    ]


    const documentTypes = [
        { value: "Invoice", label: "Invoice" },
        { value: "Delivery Challan", label: "Delivery Challan" },
        { value: "Sales Return", label: "Sales Return" },
        { value: "Credit Note", label: "Credit Note" },
        { value: "Debit Note", label: "Debit Note" },
        { value: "Other", label: "Other" },
    ];


    const appdata = useSelector((state: RootState) => state.appdata);
    const [session, setSession] = useState<Session>();
    type Employee = { id: string; name: string };
    type Transporter = { id: string; name: string };
    type Vehicle = { id: number; name: string, vehicleNumber: string };
    const [employees, setEmployees] = useState<Employee[]>([]);
    const [transporters, setTransporters] = useState<Transporter[]>([]);
    const [vehicles, setVehicles] = useState<Vehicle[]>([]);
    const [visitPurpose, setVisitPurpose] = useState('Meeting');
    const [gatepass, setGatepass] = useState<Gatepass>({
        id: 0,
        series: '',
        gatepassNumber: '',
        direction: 'IN',
        gatepassType: 1,
        gatepassTypeName: '',
        receiptMode: RECEIPT_MODE_MANUAL,
        receivedById: 0,
        receivedBy: '',
        date: moment().format("YYYY-MM-DD"),
        vehicleNumber: '',
        transporterId: 0,
        transporterName: '',
        transporterBillNumber: '',
        transporterTrackingNumber: '',
        driverNumber: '',
        driverName: '',
        requestedById: 0,
        requestedBy: '',
        isApproved: false,
        approvedBy: 0,
        approverName: '',
        securityVerifiedBy: 0,
        securityVerifierName: '',
        department: '',
        barcode: '',
        validTill: new Date(),
        purpose: '',
        remarks: '',
        visitorName: '',
        visitorMobileNumber: '',
        visitorCompany: '',
        vehicleId: 0,
        driverId: 0,
        gatepassDocuments: [],
        gatepassAttachments: []
    });

    const navigate = useNavigate();

    useEffect(() => {
        if (appdata.profile) {
            setSession(appdata.profile.profile);
        }
    }, [appdata]);

    // Placeholder: Fetch employee, transporter, and vehicle data
    useEffect(() => {
        loadVehicles();
    }, []);

    const loadVehicles = () => {
        const cachedValue = localStorage.getItem("vehicles");
        if (cachedValue) {
            setVehicles(JSON.parse(cachedValue));
            return;
        }
        ArthaGateway.getVehicles().then((response) => {
            setVehicles(response);
            localStorage.setItem("vehicles", JSON.stringify(response));
        });
    }

    const [documents, setDocuments] = useState<GatepassDocument[]>([]);
    const [attachments, setAttachments] = useState<File[]>([]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setGatepass({ ...gatepass, [name]: value } as Gatepass);
    };

    const handleVehicleChange = (e) => {
        let vehicleId = Number(e.target.value);
        let selectedVehicle = vehicles.find(v => v.id == vehicleId);
        setGatepass({ ...gatepass, vehicleNumber: selectedVehicle?.vehicleNumber || '', vehicleId: selectedVehicle?.id || 0 } as Gatepass);
    };

    const addDocument = () => {
        setDocuments([
            ...documents,
            {
                id: 0,
                documentType: "",
                documentNumber: "",
                documentDate: moment().format('YYYY-MM-DD'),
                partyId: 0,
                partyName: "",
                value: 0,
                poNumber: "",
                notes: "",
                gatepassId: 0
            },
        ]);
    };

    const updateDocument = (index, field, value) => {
        const updatedDocs = [...documents];
        updatedDocs[index][field] = value;
        setDocuments(updatedDocs);
    };

    const addAttachment = (file) => {
        if (gatepass == null) return;
        setAttachments([...attachments, file]);
    };

    const handleSubmit = async () => {
        if(gatepass == null) return;

        gatepass.securityVerifiedBy = session?.user.id || 0;
        gatepass.date = moment().format("YYYY-MM-DD");
        let year = moment().month() >= 3 ? moment().year() : moment().year() - 1;
        gatepass.series = year.toString() + "-" + (year + 1).toString();
        
        try {
            await ArthaGateway.saveGatepass(gatepass, attachments, session?.user.id || 0);
            await Swal.fire({
                icon: 'success',
                title: 'Success',
                text: 'Gatepass saved successfully!',
                timerProgressBar: true,
                timer: 2000
            });
            navigate("/");
        }
        catch (error) {
            console.error("Error in handleSubmit ->", error);
            await Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Something went wrong!',
            });
        }
    };

    const removeDocument = (index) => {
        const updatedDocs = documents.filter((_, i) => i !== index);
        setDocuments(updatedDocs);
    }

    const onSearchEmployee = (inputValue: string) => {
        return new Promise<any[]>(async (resolve) => {
            const data = await ArthaGateway.getEmployes(inputValue);
            var mappedData = data.entries.map(function (employee) {
                return {
                    value: employee,
                    label: employee.name + (employee.groupName ? ' (' + employee.groupName + ')' : '')
                };
            });
            resolve(mappedData);
        });
    };

    const onSearchDriver = (inputValue: string) => {
        return new Promise<any[]>(async (resolve) => {
            const data = await ArthaGateway.getEmployes(inputValue, 3);
            var mappedData = data.entries.map(function (employee) {
                return {
                    value: employee,
                    label: employee.name + (employee.groupName ? ' (' + employee.groupName + ')' : '')
                };
            });
            resolve(mappedData);
        });
    };

    const onSearchParty = (inputValue: string) => {
        return new Promise<any[]>(async (resolve) => {
            const data = await ArthaGateway.getParty(inputValue, 'Vendor');
            var mappedData = data.entries.map(function (party) {
                return {
                    value: party,
                    label: party.name + (party.gstin ? ' (' + party.gstin + ')' : '')
                };
            });
            resolve(mappedData);
        });
    };

    return (
        <div className="container mt-4 mb-5">
            <h3 className="mb-4">New Gatepass</h3>
            <form onSubmit={handleSubmit} className="border p-2 rounded shadow-sm">
                {/* Step 1: Direction & Type */}
                <div className="row mb-3">
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Direction</label>
                        <select className="form-select" name="direction" value={gatepass.direction} onChange={handleChange}>
                            <option value="IN">Inward</option>
                            <option value="OUT">Outward</option>
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Gatepass Type</label>
                        <select className="form-select" name="gatepassType" value={gatepass.gatepassType} onChange={handleChange}>
                            {gatepassTypes.map((type) => (
                                <option key={type.value} value={type.value}>
                                    {type.label}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <hr />
                <div className="row mb-3">
                    <div className="col-md-6 mb-3">
                        <label className="form-label fw-semibold">Requested By</label>
                        <AsyncSelect
                            cacheOptions
                            onChange={(selectedOption) => {
                                setGatepass({
                                    ...gatepass,
                                    requestedById: selectedOption ? selectedOption.value.id : 0,
                                    requestedBy: selectedOption ? selectedOption.value.name : ''
                                } as Gatepass);
                            }}
                            loadOptions={onSearchEmployee}
                            value={gatepass.requestedById == 0 ? null : { value: gatepass.requestedById, label: gatepass.requestedBy }}
                            isClearable
                            classNamePrefix="react-select"
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            placeholder="Select an employee"
                        />
                    </div>
                </div>
                <hr />
                {/* Step 2: Visitor Type */}
                {gatepass.gatepassType == GATEPASSTYPE_VISITOR && (
                    <>
                        <div className="row mb-3">
                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold">Visitor Name</label>
                                <input type="text" className="form-control" name="visitorName" value={gatepass.visitorName} onChange={handleChange} />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold">Mobile</label>
                                <input type="text" className="form-control" name="visitorMobileNumber" value={gatepass.visitorMobileNumber} onChange={handleChange} />
                            </div>
                            <div className="col-md-4 mb-3">
                                <label className="form-label fw-semibold">Company</label>
                                <input type="text" className="form-control" name="visitorCompany" value={gatepass.visitorCompany} onChange={handleChange} />
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-semibold">Purpose of Visit</label>
                                <select className="form-select" name="purpose" value={visitPurpose} onChange={(e) => setVisitPurpose(e.target.value)}>
                                    {visitPurposes.map((type) => (
                                        <option key={type.value} value={type.value}>
                                            {type.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                            {visitPurpose === 'Other' && (
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-semibold">Purpose of Visit</label>
                                    <textarea className="form-control" name="purpose" value={gatepass.purpose} onChange={handleChange}></textarea>
                                </div>
                            )}
                        </div>
                    </>
                )}

                {/* Step 3: Material Type */}
                {gatepass.gatepassType == GATEPASSTYPE_MATERIAL && (
                    <>
                        <div className="row mb-3">
                            <div className="col-md-6 mb-3">
                                <label className="form-label fw-semibold">Receipt Type</label>
                                <select className="form-select" name="receiptMode" value={gatepass.receiptMode} onChange={handleChange}>
                                    {receiptModes.map((mode) => (
                                        <option key={mode.value} value={mode.value}>
                                            {mode.label}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        {gatepass.receiptMode == RECEIPT_MODE_MANUAL && (
                            <div className="mb-3">
                                <label className="form-label fw-semibold">Received By</label>
                                <AsyncSelect
                                    cacheOptions
                                    onChange={(selectedOption) => {
                                        setGatepass({
                                            ...gatepass,
                                            receivedById: selectedOption ? selectedOption.value.id : 0,
                                            receivedBy: selectedOption ? selectedOption.value.name : ''
                                        } as Gatepass);
                                    }}
                                    loadOptions={onSearchEmployee}
                                    value={gatepass.receivedById == 0 ? null : { value: gatepass.receivedById, label: gatepass.receivedBy }}
                                    isClearable
                                    classNamePrefix="react-select"
                                    menuPortalTarget={document.body}
                                    styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    placeholder="Select an employee"
                                />
                            </div>
                        )}

                        {gatepass.receiptMode == RECEIPT_MODE_COURIER && (
                            <div className="row">
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-semibold">Courier Name</label>
                                    <input type="text" className="form-control" name="transporterName" value={gatepass.transporterName} onChange={handleChange} />
                                </div>
                                <div className="col-md-6 mb-3">
                                    <label className="form-label fw-semibold">Tracking / LR Number</label>
                                    <input type="text" className="form-control" name="transporterTrackingNumber" value={gatepass.transporterTrackingNumber} onChange={handleChange} />
                                </div>
                            </div>
                        )}

                        {(gatepass.receiptMode == RECEIPT_MODE_TRANSPORTER) && (
                            <>
                                <div className="row mb-3">
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-semibold">Transporter</label>
                                        <AsyncSelect
                                            cacheOptions
                                            onChange={(selectedOption) => {
                                                setGatepass({
                                                    ...gatepass,
                                                    transporterName: selectedOption ? selectedOption.value.name : '',
                                                    transporterId: selectedOption ? selectedOption.value.id : ''
                                                } as Gatepass);
                                            }}
                                            loadOptions={onSearchParty}
                                            value={gatepass.transporterId == 0 ? null : { value: gatepass.transporterId, label: gatepass.transporterName }}
                                            isClearable
                                            classNamePrefix="react-select"
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            placeholder="Select a transporter"
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-semibold">Vehicle</label>
                                        <input type="text" className="form-control" list="vehicleList" name="vehicleNumber" value={gatepass.vehicleNumber} onChange={handleChange} />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-semibold">Driver Name</label>
                                        <input type="text" className="form-control" name="driverName" value={gatepass.driverName} onChange={handleChange} />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-semibold">Driver Number</label>
                                        <input type="text" className="form-control" name="driverNumber" value={gatepass.driverNumber} onChange={handleChange} />
                                    </div>
                                </div>
                            </>
                        )}

                        {(gatepass.receiptMode == RECEIPT_MODE_OWNVEHICLE) && (
                            <>
                                <div className="row mb-3">
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-semibold">Vehicle</label>
                                        <select className="form-select" name="vehicleNumber" value={gatepass.vehicleNumber} onChange={handleChange} placeholder="Select vehicle">
                                            {vehicles.map((v) => (
                                                <option key={v.vehicleNumber} value={v.vehicleNumber}>
                                                    {v.vehicleNumber} - {v.name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-semibold">Driver Name</label>
                                        <AsyncSelect
                                            cacheOptions
                                            onChange={(selectedOption) => {
                                                setGatepass({
                                                    ...gatepass,
                                                    driverId: selectedOption ? selectedOption.value.id : 0,
                                                    driverName: selectedOption ? selectedOption.value.name : '',
                                                    driverNumber: selectedOption ? selectedOption.value.mobileNumber : ''
                                                } as Gatepass);
                                            }}
                                            loadOptions={onSearchDriver}
                                            value={gatepass.driverName == '' ? null : { value: gatepass.driverName, label: gatepass.driverName }}
                                            isClearable
                                            classNamePrefix="react-select"
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                            placeholder="Select a driver"
                                        />
                                    </div>
                                    <div className="col-md-4 mb-3">
                                        <label className="form-label fw-semibold">Driver Number</label>
                                        <input type="text" className="form-control" name="driverNumber" value={gatepass.driverNumber} onChange={handleChange} />
                                    </div>
                                </div>
                            </>
                        )}
                    </>
                )}

                <hr />
                {/* Step 4: Documents */}
                {gatepass.gatepassType == GATEPASSTYPE_MATERIAL && (
                    <>
                        <div className="mt-4">
                            <div className="d-flex justify-content-between align-items-center">
                                <h5>Documents</h5>
                                <button type="button" className="btn btn-outline-primary btn-sm" onClick={addDocument}>
                                    + Add Document
                                </button>
                            </div>
                            {documents.map((doc, i) => (
                                <div key={i} className="border rounded p-3 mt-3 bg-white">
                                    <div className="row">
                                        <div className="col-12 mb-3">
                                            <label className="form-label fw-semibold">Vendor</label>
                                            <AsyncSelect
                                                cacheOptions
                                                onChange={(selectedOption) => {
                                                    const updatedDocs = [...documents];
                                                    updatedDocs[i].partyId = selectedOption ? selectedOption.value.id : '';
                                                    updatedDocs[i].partyName = selectedOption ? selectedOption.value.name : '';
                                                    setDocuments(updatedDocs);
                                                }}
                                                loadOptions={onSearchParty}
                                                value={doc.partyId == 0 ? null : { value: doc.partyId, label: doc.partyName }}
                                                isClearable
                                                classNamePrefix="react-select"
                                                menuPortalTarget={document.body}
                                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                placeholder="Select vendor"
                                            />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label fw-semibold">Document Type</label>
                                            <select className="form-select" value={doc.documentType} onChange={(e) => updateDocument(i, "documentType", e.target.value)}>
                                                <option value="">Select</option>
                                                {documentTypes.map((type) => (
                                                    <option key={type.value} value={type.value}>{type.label}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label fw-semibold">Document Number</label>
                                            <input type="text" className="form-control" value={doc.documentNumber} onChange={(e) => updateDocument(i, "documentNumber", e.target.value)} />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label fw-semibold">Document Date</label>
                                            <input type="date" className="form-control" value={doc.documentDate} onChange={(e) => updateDocument(i, "documentDate", e.target.value)} />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <label className="form-label fw-semibold">Value</label>
                                            <input type="number" className="form-control" value={doc.value} onChange={(e) => updateDocument(i, "value", e.target.value)} />
                                        </div>
                                        <div className="col-md-3 mb-3">
                                            <button type="button" className="btn btn-sm btn-danger" aria-label="Close" onClick={() => {
                                                removeDocument(i);
                                            }}>
                                                <FontAwesomeIcon icon={faTrash} className="me-2" />
                                                Remove
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </>
                )}
                <hr />
                {/* Step 5: Attachments */}
                <div className="mt-4">
                    <h5>Photos</h5>
                    <input
                        type="file"
                        className="form-control mt-2"
                        style={{ display: "none" }}
                        multiple
                        onChange={(e) => {
                            if (e.target.files) {
                                Array.from(e.target.files).forEach((file) => addAttachment(file));
                            }
                        }}
                    />
                    <div className="row mt-2 d-flex flex-wrap">
                        {attachments.map((file, idx) => (
                            <div key={idx} className="col-6 col-md-4 mb-2 border rounded p-2 bg-white">
                                <img
                                    src={file ? URL.createObjectURL(file) : ''}
                                    alt={`Attachment ${idx + 1}`}
                                    style={{ width: "100px", height: "100px", objectFit: "cover" }}
                                />
                                <button type="button" className="btn btn-sm btn-danger mt-1 w-100" aria-label="Close" onClick={() => {
                                    setAttachments(attachments.filter((_, i) => i !== idx));
                                }}>
                                    <FontAwesomeIcon icon={faTrash} className="me-2" /> Remove
                                </button>
                            </div>
                        ))}
                    </div>                    
                    <div className="btn btn-outline-dark mt-2" onClick={() => {
                        (document.querySelector('input[type="file"]') as HTMLInputElement | null)?.click();
                    }}>
                        <FontAwesomeIcon icon={faCamera} /> Add Photo
                    </div>
                </div>

                <hr />

                <div className="row mb-3">
                    <div className="col-md-12 mb-3">
                        <label className="form-label fw-semibold">Remarks</label>
                        <textarea className="form-control" name="remarks" value={gatepass.remarks} onChange={handleChange}></textarea>
                    </div>
                </div>

                <div className="row mt-4">
                    <button type="button" className="btn btn-success w-100" onClick={() => handleSubmit()}>
                        Submit Gatepass
                    </button>
                </div>
            </form>
        </div>
    );
};